module.exports = __webpack_public_path__ + "img/icon-menu.48b1d71f.svg";